<style>
#profileNMT .v--modal-box.v--modal {
  min-height: 285px !important;
  min-width: 900px !important;
}
#profileNMT *:not(.v-icon) {
  font-size: 12px;
}
#profileNMT .geometry__wrapper {
  line-height: 40px;
  justify-content: space-around;
}
#profileNMT .profileList {
  width: 100%;
  margin-bottom: 10px;
}
#profileNMT .v-list__tile__title {
  text-align: center;
}
#profileNMT .geometry__wrapper span {
  text-transform: uppercase;
}
#profileNMT .geometry__wrapper .flex {
  align-items: center;
  display: flex;
}
#profileNMT .v-list {
  padding: 0px;
  border: 1px solid lightgray;
}
#profileNMT .border--left {
  border-left: 1px solid lightgray;
}
</style>

<template>
  <Modal
    modalName="profileNMT"
    title="PROFIL PODŁUŻNY NMT"
    :buttons="['']"
    @opened="opened()"
    @closed="closed()"
  >
    <div>
      <v-layout
        row
        wrap
        class="geometry__wrapper"
        style="justify-content: unset"
        v-show="!profileLine"
      >
        <v-icon
          class="table__btn--green"
          title="Dodaj linię profilu"
          @click="addProfileLine"
        >add_circle
        </v-icon>
        <span>
          Narysuj linię profilu
        </span>

      </v-layout>
      <v-layout
        row
        wrap
        class="geometry__wrapper"
        v-if="profileLine"
      >
        <v-flex xs3>
          <span>
            Długość profilu
          </span>
          <span>{{": "+ lineLength.toFixed(2).toString()+" m" }}</span>

        </v-flex>
        <v-flex xs3>
          <v-icon
            class="btn__subheader"
            title="Przybliż do linii profilu"
            @click="zoomToProfileLine"
          >
            zoom_in
          </v-icon>
          <span>
            Przybliż do linii profilu
          </span>
        </v-flex>
        <v-flex xs3>
          <v-icon
            class="btn__subheader table__btn--red"
            title="Usuń linię profilu"
            @click="removeProfileLine"
          >
            delete
          </v-icon>
          <span>
            Usuń linię profilu
          </span>
        </v-flex>
      </v-layout>
      <v-layout
        v-show="profileLine"
        row
        wrap
        class="geometry__wrapper"
      >
        <v-flex xs3>
          <v-text-field
            height="16"
            label="Interwał"
            v-model="interval"
            @keypress="isNumber($event)"
            :rules="[isValidNumber]"
            ref="asdf"
            title="Pobranie wartości z NMT co zadaną odległość. Domyślnie: 1 metr."
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-icon
            :disabled="!profileLine||tooLongInterval"
            title="Generuj wykres"
            @click="generateChart"
            dark
            color="#2a579a"
            v-if="profileLine"
            style="margin-right: 0"
          >settings</v-icon>
          <span>Generuj wykres</span>
        </v-flex>
        <v-flex xs3 />

      </v-layout>
      <v-layout v-show="chartGenerated">
        <v-list class="profileList">
          <v-list-tile class="list--el">
            <v-list-tile-title class="list--el--bold">Wysokość początku przekroju [m]</v-list-tile-title>
            <v-list-tile-title class="border--left list--el--bold">Wysokość końca przekroju [m]</v-list-tile-title>
            <v-list-tile-title class="border--left list--el--bold">Średni spadek wysokości [°]</v-list-tile-title>
          </v-list-tile>
          <template v-for="(row, index) in profileData">
            <v-list-tile
              class="list--el"
              :key="index"
              style="border:none"
            >
              <v-list-tile-title>{{row.start}}</v-list-tile-title>
              <v-list-tile-title class="border--left">{{row.end}}</v-list-tile-title>
              <v-list-tile-title class="border--left">{{row.slope}}</v-list-tile-title>

            </v-list-tile>
          </template>
        </v-list>
      </v-layout>
      <v-layout
        row
        wrap
      >
        <canvas
          v-show="chartGenerated"
          id="profileChart"
        ></canvas>
      </v-layout>

    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import {LineString} from "ol/geom";
import GeoJSON from "ol/format/GeoJSON";

export default {
  components: {
    Modal
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  data: () => ({
    profileLine: undefined,
    profileData: [{
      start: 'Brak danych',
      end: 'Brak danych',
      slope: 'Brak danych',
    }],
    interval: 1.0,
    chartGenerated: false,
    tooLongInterval: false,
    lineLength: undefined,
    labels: [],
    profileLineChart: undefined
  }),
  methods: {
    isValidNumber(v) {
      if(!v) {
        this.tooLongInterval = true;
        return "Wprowadź wartość";
      }
      if(parseFloat(v) > this.lineLength) {
        this.tooLongInterval = true;
        return "Interwał nie może być dłuższy niż linia";
      }
      this.tooLongInterval = false;
      return true;
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    addProfileLine() {
      this.$root.$emit("addNewLine", "profile");
      this.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby rozpocząć rysowanie linii przekroju"
      );
    },
    removeProfileLine() {
      this.profileLine = undefined;
      this.chartGenerated = false;
      this.$root.$emit("removeMapLayer");
      this.profileLineChart = undefined;
    },
    zoomToProfileLine() {
      this.$root.$emit("zoomToLineString", this.profileLine);
    },
    addGeometry(data) {
      this.profileLine = new LineString(data.coordinates);
      this.lineLength = this.profileLine.getLength();
      this.$refs.asdf.validate();
    },
    opened() {
      this.interval = 1.0;
      this.profileLine = undefined;
      this.lineLength = undefined;
      this.chartGenerated = false;
      this.tooLongInterval = false;
      this.labels = [];
      this.profileLineChar = undefined;
    },
    closed() {
      this.removeProfileLine();
      this.profileData = []
    },
    splitLine(data) {
      let points = [];
      let intervalLabel = 0;
      this.labels = [];

      this.lineLength = this.profileLine.getLength();
      let step = parseFloat(this.interval) / this.lineLength;
      for(let i = 0.0; i < 1.0; i += step) {
        points.push(this.profileLine.getCoordinateAt(i));
        this.labels.push(intervalLabel + " m");
        intervalLabel += parseFloat(this.interval);
      }
      data.coordinates = points;
      return data;
    },
    generateChart() {
      let parser = new GeoJSON();
      let data = this.splitLine(parser.writeGeometryObject(this.profileLine));
      if(data) {
        this.$store.dispatch("generateChart", data).then(response => {
          if(response.status == 200) {
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie wygenerowano wykres"
            );
            this.drawChart(response.data);
            this.profileData[0] = {
              start: response.data[0].toFixed(2),
              end: response.data[response.data.length - 1].toFixed(2),
              slope: this.calcSlope(response.data).toFixed(2)
            }
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Podczas generowania wykresu wystąpił błąd"
            );
          }
        });
      } else {
        this.tooLongInterval = true;
      }
    },
    drawChart(data) {
      const ctx = document.getElementById("profileChart").getContext("2d");
      this.profileLineChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.labels,
          datasets: [
            {
              label: "Profil podłużny terenu",
              backgroundColor: "rgba(0,0,0,0)",
              borderColor: "rgb(255, 99, 132)",
              data: data
            }
          ]
        },
        options: {
          scales: {
            yAxes: [
              {
                id: "y-axis-1",
                display: true,
                position: "left",
                scaleLabel: {
                  display: true,
                  labelString: "m n.p.m."
                }
              }
            ]
          }
        }
      });
      this.chartGenerated = true;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if(
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    calcSlope(points) {
      // Zwraca spadek wysokości między punktem początkowym a końcowym w stopniach
      return Math.atan(
        Math.abs(points[0] - points[points.length - 1]) / this.lineLength
      ) * 180 / Math.PI;
    }
  },
  mounted() {
    this.$root.$on("profileLineGeometry", this.addGeometry);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/analysis/modals/ProfileNMT.vue